import i18n from '@/i18n'

export default {
  detailHeadersWithCRUD () {
    return [
      {
        sortable: true,
        text: i18n.t('product'),
        value: 'product.name'
      },
      {
        sortable: true,
        text: i18n.t('rate'),
        value: 'cost.rate',
        align: 'right'
      },
      {
        text: i18n.t('actions'),
        value: 'action',
        align: 'center'
      }
    ]
  },

  detailHeadersNoCRUD () {
    return [
      {
        sortable: true,
        text: i18n.t('product'),
        value: 'product.name'
      },
      {
        sortable: true,
        text: i18n.t('rate'),
        value: 'cost.rate',
        align: 'right'
      }
    ]
  }
}
